export default function SuggestedDish(props) {
    const { dish } = props;

    return (
        <div className="suggested-drink py-1 px-3 text-sm rounded-b-lg bg-grey-400">
            <p><span className="font-bold">Ottimo con:</span> <span className="capitalize">{dish.suggested_drink.name}</span></p>
        </div>
    );
}
